export default {
	methods: {
		/**
		 * Accepts this.$store.getters.apiPath
		 * @param {*} path
		 * @returns
		 */
		getUrlHost (path) {
			if (path.includes('www.lelandlittle.com')) {
				return 'https://www.lelandlittle.com'
			} else if (path.includes('www.lelandlittle.net')) {
				return 'https://www.lelandlittle.net'
			} else if (path.includes('qa.lelandlittle.net')) {
				return 'https://qa.lelandlittle.net'
			} else {
				return 'https://www.lelandlittle.com'
			}
		}
	}
}
